module.exports = __webpack_public_path__ + "img/Sierra Leone.59afbdb3.svg";